import { render } from "./Prayers.vue?vue&type=template&id=3291c9be"
import script from "./Prayers.vue?vue&type=script&lang=js"
export * from "./Prayers.vue?vue&type=script&lang=js"

import exportComponent from "/Users/q/Documents/projects/religious-app/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__